export default function processWeeksRangesandVersions(weekMasterData) {
    const weeks = {};

    weekMasterData.forEach((doc) => {
        const wno = doc.wk_no;

        if (!weeks[wno]) {
            // first day of this week → initialize
            weeks[wno] = {
                week_no: wno,
                start: doc.dates,
                end: doc.dates,
                versions: doc.versions || [], // take versions only once
            };
        } else {
            // update only end date
            weeks[wno].end = doc.dates;
        }
    });

    return Object.values(weeks);
}
